import { List, Skeleton } from 'antd'
import Avatar from 'components/Avatar'
import CustomTag from 'components/CustomTag'
import Flex from 'components/Flex'
import CalendarIcon from 'components/icons/CalendarIcon'
import CarIcon from 'components/icons/CarIcon'
import LocationMarkIcon from 'components/icons/LocationMarkIcon'
import {
  BoldText,
  BottomData,
  BottomInfo,
  FlexWraper,
  InfoItem,
  InfoSection,
  LightText,
  ListWraper,
  SectionItem,
  SectionWrapper,
  TitleName,
  Wrapper,
} from 'modules/Drive/Partials/ScheduleDriveDrawer/Partials/ScheduleList/Style/style'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useSelector } from 'react-redux'
import rolesApi from 'utils/corporateRequest'

const ScheduleList = ({ date }) => {
  const instituteId = useSelector(state => state.auth.instituteDetails.id)
  const [listData, setListData] = useState([])
  const [driveList, setDriveList] = useState([])
  const [loading, setLoading] = useState(false)
  const [pageNum, setPageNum] = useState(0)

  useEffect(() => {
    setListData([])
    getDriveList()
  }, [date])

  useEffect(() => {
    if (driveList?.result?.length) {
      let list = [...listData, ...driveList.result]
      setListData(list)
    }
  }, [driveList?.result])
  const getDriveList = async () => {
    if (!moment(date, 'DD-MM-YYYY', true).isValid()) {
      console.error('Invalid date format, API call not triggered.')
      return
    }
    const formattedDate = moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD')

    setLoading(true)
    try {
      let list = await rolesApi.get(
        `/corporates/instituteCampus/${instituteId}/drive/list?instituteStatus=CONFIRMED&dates=${formattedDate}&pageLimit=10&pageNo=${pageNum}`
      )
      setPageNum(pageNum + 1)
      setDriveList(list?.data)
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  return (
    <SectionWrapper>
      <FlexWraper>
        <TitleName>
          <BoldText>Scheduled Drive {`(${driveList?.count || 0})`}</BoldText>
          <LightText>{date}</LightText>
        </TitleName>
      </FlexWraper>
      <Wrapper id="scrollableDiv">
        <InfiniteScroll
          dataLength={listData?.length}
          next={() => {
            getDriveList()
          }}
          hasMore={driveList?.totalPage > pageNum}
          loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
          scrollableTarget="scrollableDiv"
        >
          <List
            bordered={false}
            dataSource={listData}
            loading={loading}
            renderItem={(drive, index) => (
              <Fragment key={index + 'listData'}>
                <List.Item>
                  <SectionItem key={index + 'valueData'}>
                    <ListWraper>
                      <Avatar
                        background
                        src={''}
                        size={36}
                        IconName={drive?.corporate?.name?.split('')?.[0]}
                        font={18}
                      />
                      <InfoSection>
                        <InfoItem>
                          <TitleName>
                            <BoldText>{drive?.corporate?.name}</BoldText>
                            <LightText>{drive?.corporate?.industry}</LightText>
                          </TitleName>
                          <Flex flexStart>
                            <CustomTag
                              color="green"
                              message="Confirmed"
                              bordered={true}
                            />
                          </Flex>
                        </InfoItem>
                        <InfoItem>
                          <BottomInfo>
                            <CarIcon />
                            <BottomData>
                              {drive?.driveMode?.replace('_', ' ')}
                            </BottomData>
                          </BottomInfo>
                          <BottomInfo>
                            <LocationMarkIcon />
                            <BottomData>{drive?.hostCollegeName}</BottomData>
                          </BottomInfo>
                          <BottomInfo>
                            <CalendarIcon />
                            <BottomData>
                              {moment(drive?.startDate).format('DD/MM/YYYY')}
                            </BottomData>{' '}
                            -
                            <BottomData>
                              {moment(drive?.endDate).format('DD/MM/YYYY')}
                            </BottomData>
                          </BottomInfo>
                        </InfoItem>
                      </InfoSection>
                    </ListWraper>
                  </SectionItem>
                </List.Item>
              </Fragment>
            )}
          />
        </InfiniteScroll>
      </Wrapper>
    </SectionWrapper>
  )
}

export default ScheduleList
